/*
 *   File : chip.js
 *   Author : https://evoqins.com
 *   Description : Chip component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React from 'react';

// custom components
import CustomTooltip from './custom-tooltip';

// custom styles
import color from '../../Style/color.scss'

const Chip = (props) => {
    return (

        <>
            {props.type === 2 ?
                <div className='e-border-0-5px-seashell border-radius-12 py-1 padding-6px-lr d-flex align-items-center gap-1'>
                    {props.hideDot !== true &&
                        <div className={`${props.dotClass ? props.dotClass : "e-bg-green-crayola"}  w-6px h-6px rounded-circle`}></div>
                    }
                    <p className='mb-0 e-text-linen e-primary-font e-font-10 e-font-weight-400 line-height-10px text-capitalize'>
                        {props.label}
                    </p>
                </div>
                :
                <div className={`d-flex  align-items-center gap-4px ${props.textAlign ? props.textAlign : 'justify-content-center'} `}>
                    <span className={`${props.className} ${props.bgColor}  e-text-white e-primary-font e-font-12 e-font-weight-400 line-height-16px border-radius-12 py-1 px-2`}
                        onClick={props.onClick}>
                        {props.label}
                    </span>

                    {props.tooltip === true &&
                        <CustomTooltip size={16}
                            color={color.charleston_green_light}
                            icon={true}
                            id={`tooltip-${props.id}`}
                            content={props.content} />
                    }
                </div>
            }
        </>
    )
}

export default Chip;
